export default [
  {
    type: "image",
    label: "Imagem",
    icon: "fa-light fa-image"
  },
  {
    type: "video",
    label: "Vídeo",
    icon: "fa-light fa-video"
  },
  {
    type: "text",
    label: "Texto",
    icon: "fa-light fa-text"
  },
  // {
  //   type: "image-text",
  //   label: "Imagem e Texto",
  //   icon: ["fa-light fa-image", "fa-light fa-text"]
  // },
  {
    type: "timer",
    label: "Cronômetro",
    icon: "fa-light fa-clock"
  }
  // {
  //   type: "rating",
  //   label: "Avaliação",
  //   icon: "fa-light fa-star"
  // }
];
